// Firestore
import { firestore } from '@breakroom-nx/apis';
import { collection, getDocs, getDoc, doc } from 'firebase/firestore';

// Database
import { database } from '@breakroom-nx/apis';
import { ref, get, child } from 'firebase/database';

import { RoomMember, Coordinate, IMessageExt } from '@breakroom-nx/helpers';
import { IMessage } from 'react-native-gifted-chat';

const brooklyn = { lat: 40.62, lon: -73.975 };
export class Room {
  id: string = '';
  title: string = '';
  avatar: string = '';
  theme: string = '';
  location: Coordinate = { latitude: brooklyn.lat, longitude: brooklyn.lon };
  geohash: string = '';
  vibe: string = '';
  vibeIcon: string = '';
  created: Date = new Date();
  expires: Date = new Date();
  newMessage: boolean = true;
  isDirect: boolean = false;

  // Optional
  messages?: IMessage[];
  lastMessage?: IMessageExt;
  lastRead?: Date = new Date();
  members?: RoomMember[];

  public constructor(init?: Partial<Room>) {
    Object.assign(this, init);
  }

  streakDuration() {
    return new Date(new Date().getTime() - this.created.getTime());
  }

  timeLeft() {
    return (
      ((this.expires.getTime() - new Date().getTime()) / (1000 * 60 * 60)) * 100
    );
  }
}

// Firestore Data Converter
export const roomConverter = {
  toFirestore: (room: Room) => {
    return {
      title: room.title,
      avatar: room.avatar,
      theme: room.theme,
      location: room.location,
      geohash: room.geohash,
      created: room.created,

      // newMessage: boolean;
      // isDirect: boolean;
      // streakDuration: Date;
      // timeLeft: number;

      vibe: room.vibe,
      vibeIcon: room.vibeIcon,
      // messages?: Message[];
    };
  },
  fromFirestore: (snap: any) => {
    const data: any = snap.data();
    const roomID = snap.id;
    return new Room({
      id: roomID,
      title: data.title,
      avatar: data.avatar,
      theme: data.theme,
      location: data.location,
      geohash: data.geohash,
      created: data.created.toDate(),
      expires: data.expires.toDate(),
      vibe: data.vibe,
      vibeIcon: data.vibeIcon,
    });
  },
};

// Get Chat Room from Firebase
export async function getChatRoom(
  roomID: string,
  currentUserUID?: string
): Promise<Room | null> {
  // console.info('Fetching Room:', roomID);
  try {
    // console.info('Fetching Room (Realtime DB):', roomID);
    const dbRef = ref(database);

    // Fetch room data
    const roomSnap = await get(child(dbRef, `chats/${roomID}`));
    if (!roomSnap.exists()) {
      // console.log(`ERROR: Room with ID [${roomID}] DOES NOT EXIST.`);
      return null;
    }
    const data = roomSnap.val();

    // Build Room instance
    const room = new Room({
      id: roomID,
      title: data.title,
      avatar: data.avatar,
      theme: data.theme,
      location: data.location,
      geohash: data.geohash,
      created: data.created ? new Date(data.created) : new Date(),
      expires: data.expires ? new Date(data.expires) : new Date(),
      vibe: data.vibe,
      vibeIcon: data.vibeIcon,
      lastMessage: data.lastMessage,
      lastRead:
        currentUserUID && data.lastRead
          ? data.lastRead[currentUserUID]
          : undefined,
    });

    // Fetch members
    const membersSnap = await get(child(dbRef, `members/${roomID}`));
    if (membersSnap.exists()) {
      const members: RoomMember[] = [];
      membersSnap.forEach((doc) => {
        const documentData = doc.val();
        const memberData: RoomMember = {
          uid: doc.key ?? '',
          flair: documentData.flair,
          isHost: documentData.isHost,
          username: documentData.username,
          // avatar: documentData.avatar,
          // geoCode: documentData.geoCode,
        };
        members.push(memberData);
      });
      room.members = members;
    }

    // Optionally fetch lastMessage if not included in room data
    if (!room.lastMessage) {
      const lastMsgSnap = await get(
        child(dbRef, `chats/${roomID}/lastMessage`)
      );
      if (lastMsgSnap.exists()) {
        room.lastMessage = lastMsgSnap.val();
      }
    }

    return room;
  } catch (err) {
    // console.log('ERROR: Unable to fetch room from Realtime Database.', err);
    return null;
  }
}
